import { Component, OnInit, Inject } from '@angular/core';
import { ChangeJobsiteComponent } from '../../../../modules/manage-equipment/components/change-jobsite/change-jobsite.component';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../../shared/services/loading.service';
import { AdditionalObservationListViewModel } from '../../models/create-inspection.model';
import { Customer, Model, Family, Tuple } from '../../../../entities';
import { NewInspectionService } from '../../services/new-inspection.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GenericIdName } from '../../../../../app/shared/models/common-search-filters.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-new-observation-list-property',
  templateUrl: './new-observation-list-property.component.html',
  styleUrls: ['./new-observation-list-property.component.scss']
})

export class NewObservationListPropertyComponent implements OnInit {
  createfromObsList:boolean;
  additionalObservationList = new AdditionalObservationListViewModel();
  customer: Customer;
  model: Model;
  family: Family;

  isEditing= false;

  saving = false;

  title = '';

  inspectionDraftId: number;
  inspectionId: number;
  descriptionControl: FormControl;
  fg: FormGroup;
  additionalObservationListCheck: AdditionalObservationListViewModel[];
  showEnable = true;
  QuestionTypes:GenericIdName[];
  constructor( public dialogRef: MatDialogRef<ChangeJobsiteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,
    private _loading: LoadingService,
    private inpsectionService: NewInspectionService) { }

  ngOnInit() {
    this.createfromObsList=this.data.createfromObsList;
    if (this.data.model ) {
      this.additionalObservationList.CustomerId = this.data.model.CustomerId;
      this.additionalObservationList.ModelId = this.data.model.ModelId;
      this.additionalObservationList.FamilyId = this.data.model.FamilyId;
      this.additionalObservationList.Id = this.data.model.Id;
      this.additionalObservationList.Disabled = this.data.model.Disabled;
      this.additionalObservationList.Title = this.data.model.Title;
      this.additionalObservationList.QuestionTypeId = this.data.model.QuestionTypeId;
      this.additionalObservationList.QuestionTypeId = this.data.model.QuestionTypeId;
      this.isEditing = true;
    }    
    else {
      this.customer = this.data.selectedCustomer;
      this.model = this.data.selectedModel;
      this.family = this.data.selectedFamily;
      this.inspectionDraftId = this.data.inspectionDraftId;
      this.inspectionId = this.data.inspectionId;
      this.additionalObservationListCheck = this.data.additionalObservationListCheck;
      
      if (this.customer !== undefined) {
        this.title =  this.customer.Title;
        this.additionalObservationList.CustomerId = this.customer.Id;
      }
      if (this.model !== undefined) {
        this.title = this.model.Title;
        this.additionalObservationList.ModelId = this.model.Id;
      }
      if (this.family !== undefined) {
        this.title = this.family.Title;
        this.additionalObservationList.FamilyId = this.family.Id;
      }
      if (this.inspectionDraftId !== undefined) {
        this.title = 'Add New Inspection Observations';
        this.showEnable = false;
      }
      if (this.inspectionId !== undefined) {
        this.title = 'Add New Inspection Observations';
        this.showEnable = false;
      }
    }

    this.descriptionControl = new FormControl(this.additionalObservationList.Title, [
      Validators.required,
    ]);
    this.fg = new FormGroup({
      descriptionControl: this.descriptionControl,
    });
  }
  save() {
    this.saving = true;
    this._loading.startLoading();
    if (this.isEditing) {
      this.inpsectionService.updateObservationListProperties(this.additionalObservationList).subscribe(r => {
         this.message(r);
      });
    }    else {
      if (this.customer !== undefined) {
        this.inpsectionService.saveNewCustomerLevelAdditionalObservationList(this.additionalObservationList).subscribe(r => {
          this.message(r);
        });
      } else
      if (this.model !== undefined) {
        this.inpsectionService.saveNewModelLevelAdditionalObservationList(this.additionalObservationList).subscribe(r => {
          this.message(r);
        });
      } else
      if (this.family !== undefined) {
        this.inpsectionService.saveNewFamilyLevelAdditionalObservationList(this.additionalObservationList).subscribe(r => {
          this.message(r);
        });
      } else  if (this.inspectionDraftId !== undefined) {
        if(this.inspectionId != undefined){
          const title = this.additionalObservationList.Title;
          const exists = this.additionalObservationListCheck?.some(x => x.Title?.trim().toLowerCase() === title?.trim().toLowerCase());
          if (exists) {
            this._notification.warn(
              'Duplicate Observation',
              'An observation with the same title already exists.'
            );
            this.saving = false;
            this._loading.finishedLoading();
            return;
          }
          this.saving = false;
          this._notification.success('Added new Observation List Successfully');
          this.dialogRef.close({close: true, title: title});
          this._loading.finishedLoading();
        //   this.inpsectionService.addObservationListOnInterpretation(this.inspectionId, this.additionalObservationList.Title).subscribe(r => {
        //   this.saving = false;
        //   this._loading.finishedLoading();
        //   this._notification.success('Added new Observation List Successfully');
        //   this.dialogRef.close(true);
        // }, error => {
        //   this.saving = false;
        //   this._loading.finishedLoading();
        //   this._notification.error('Failed to Save Observation List');
        // });
        } else {
            this.inpsectionService.addObservationListOnTheFly(this.inspectionDraftId, this.additionalObservationList.Title).subscribe(r => {
            this.saving = false;
            this._loading.finishedLoading();
            this._notification.success('Added new Observation List Successfully');
            this.dialogRef.close({close: true, title: ''});
          }, error => {
            this.saving = false;
            this._loading.finishedLoading();
            this._notification.error('Failed to Save Observation List');
          });
        }
      } else  if (this.inspectionId !== undefined) {
        const title = this.additionalObservationList.Title;
        const exists = this.additionalObservationListCheck?.some(x => x.Title?.trim().toLowerCase() === title?.trim().toLowerCase());
          if (exists) {
            this._notification.warn(
              'Duplicate Observation',
              'An observation with the same title already exists.'
            );
            this.saving = false;
            this._loading.finishedLoading();
            return;
          }
        this.inpsectionService.addObservationListOnInterpretation(this.inspectionId, this.additionalObservationList.Title).subscribe(r => {
          this.saving = false;
          this._loading.finishedLoading();
          this._notification.success('Added new Observation List Successfully');
          this.dialogRef.close(true);
        }, error => {
          this.saving = false;
          this._loading.finishedLoading();
          this._notification.error('Failed to Save Observation List');
        });
      }
    }
  }


  message(response: Tuple) {
    this.saving = false;
    this._loading.finishedLoading();
    if (response.m_Item1 > 0 ) {
      this._notification.success('Saved Observation List Successfully');
      this.dialogRef.close(true);
    }    else {
      this._notification.error('Failed to Save Observation List');
    }
  }

  onNoClick() {
    this.dialogRef.close(false);
  }
}
